// extracted by mini-css-extract-plugin
module.exports = {"navigation":"styles_navigation__3c48N","holder":"styles_holder__2xxAA","active":"styles_active__3I80t"};